<template>
    <div v-loading="$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.loading">
        <el-form
                ref="$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail"
                :model="$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail"
                :label-position="'center'"
                label-width="80px">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form-item
                            v-if="$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.school_status"
                            label="学校" prop="school">
                        <el-select
                                v-model="$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.school_id"
                                filterable remote
                                :remote-method="handleSearchSchool"
                                placeholder="请选择学校"
                                style="width: 180px">
                            <el-option
                                    v-for="item in $parentInfo.initInformation.schools"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                        <el-button @click="handleSchoolInputChange()" size="mini" style="width: 40px;height: 28px">+</el-button>
                    </el-form-item>
                    <el-form-item v-else label="学校">
                        <el-input style="width: 180px"
                                  v-model="$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.defined_school"
                                  placeholder="输入学校"
                        ></el-input>
                        <el-button @click="handleSchoolInputChange()" size="mini" style="width: 40px;height: 28px">-</el-button>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="年级">
                        <el-select
                                v-model="$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.grade_id"
                                align="right"
                                placeholder="在读年级"
                                style="width: 180px">
                            <el-option
                                    v-for="item in $parentInfo.initInformation.grades"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="班级">
                        <el-select
                                v-model="$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.schoolClass_id"
                                align="right"
                                placeholder="在读班级"
                                style="width: 180px">
                            <el-option
                                    v-for="item in $parentInfo.initInformation.schoolClasses"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="入学日期">
                        <el-date-picker
                                v-model="$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.school_year"
                                type="date"
                                placeholder="选择日期"
                                style="width: 180px">
                        </el-date-picker>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="毕业日期">
                        <el-date-picker
                                v-model="$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.graduated_at"
                                type="date"
                                placeholder="选择日期"
                                style="width: 180px">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>
        <div class="text-right">
            <el-button type="primary" @click="handleUpdateEducationalExperiences()"
                       :loading="$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.button_loading">
                修改
            </el-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Dialog_StudentEducationalExperiencesDetail',
        data() {
            return {
            }
        },
        created() {
            this.$parentInfo = this.$root.$children[0].$refs['dashboard'].$refs[this.$route.path];
            this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.loading = true;
            this.handleShowEducationalExperiences();
            this.handleSearchSchool("");
        },
        // mounted() {
        //     this.$nextTick(() => {
        //     })
        // },
        methods: {
            handleSchoolInputChange() {
                if (this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.school_status === true) {
                    this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.school_status = false;
                } else {
                    this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.school_status = true;
                }
            },
            handleShowEducationalExperiences() {
                this.$wApi.send(this.$parentInfo.path, 'showEducationExperiences', {
                    'educationalExperience_id': this.$store.state.modal.data.id,
                });
            },
            handleSearchSchool(query) {
                this.$wApi.send(this.$parentInfo.path, 'search', {
                    'type': 'searchSchool',
                    'schoolKeyName': query,
                });
            },
            handleUpdateEducationalExperiences() {
                this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.button_loading = true;
                if (this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.graduated_at !== '') {
                    this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.graduated_at = this.$moment(this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.graduated_at).format('YYYY-MM-DD');
                }
                if (this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.school_year !== '') {
                    this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.school_year = this.$moment(this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.school_year).format('YYYY-MM-DD');
                }
                this.$wApi.send(this.$parentInfo.path, 'updateEducationalExperiences', {
                    'educationalExperience_id': this.$store.state.modal.data.id,
                    'student_id': this.$parentInfo.student_id,
                    'defined_school': this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.defined_school != null ? this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.defined_school : null,
                    'school_id': this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.school_id,
                    'graduated_at': this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.graduated_at,
                    'school_year': this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.school_year,
                    'grade_id': this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.grade_id,
                    'schoolClass_id': this.$parentInfo.studentEducationalExperiences.dialog_StudentEducationalExperiencesDetail.educationalExperiencesDetail.schoolClass_id,
                    'school_type': '',
                });
            },

        }
    }
</script>

<style scoped>

</style>
